<template>
    <div>
        <h2 is="sui-header">{{ $t('gateway.mediasConfig.title') }}</h2>

        <sui-form-field>
            <sui-checkbox
                :label="$t('gateway.mediasConfig.isIterative')"
                v-model="activeGateway.configuration.mediaConfiguration.isIterative"
            />
        </sui-form-field>

        <sui-form-field>
            <sui-checkbox
                :label="$t('gateway.mediasConfig.ignoreExistingMediaFileName')"
                v-model="activeGateway.configuration.mediaConfiguration.ignoreExistingMediaFileName"
            />
        </sui-form-field>

        <div v-if="fetchMethod !== 'URL'">
            <sui-form-fields inline>
                <label>{{ $t('gateway.mediasConfig.fetchMethod') }}</label>
                <sui-form-field>
                    <sui-checkbox
                        radio
                        label="URL"
                        value="URL"
                        v-model="activeGateway.configuration.mediaConfiguration.fetchMethod"
                        required
                    />
                </sui-form-field>
                <sui-form-field>
                    <sui-checkbox
                        radio
                        label="URL Base64"
                        value="URL_BASE64"
                        v-model="activeGateway.configuration.mediaConfiguration.fetchMethod"
                        required
                    />
                </sui-form-field>
                <sui-form-field>
                    <sui-checkbox
                        radio
                        label="Local"
                        value="LOCAL"
                        v-model="activeGateway.configuration.mediaConfiguration.fetchMethod"
                        required
                    />
                </sui-form-field>
            </sui-form-fields>

            <sui-form-field>
                <label>{{ $t('gateway.mediasConfig.folder') }}</label>
                <input
                    :disabled="['URL', 'URL_BASE64'].includes(mediaFetchMethod)"
                    @input="validateMediaFolder"
                    type="text"
                    v-model="mediaFolder"
                    required
                    placeholder="/path/to/folder"
                />
                <label>{{ $t('gateway.mediasConfig.dataField') }}</label>
                <input
                    :disabled="mediaFetchMethod !== 'URL_BASE64'"
                    type="text"
                    v-model="mediaDataField"
                    required
                    placeholder="response.content"
                />
            </sui-form-field>
            <sui-form-fields :fields="'three'">
                <sui-form-field>
                    <label>{{ $t('gateway.mediasConfig.downloadDelay') }}</label>
                    <input type="number" v-model="activeGateway.configuration.mediaConfiguration.downloadDelay">
                    <sui-list bulleted class="mini preformated-input-list no-bullet">
                        <sui-list-item>
                            {{ $t('gateway.mediasConfig.downloadDelayInfo') }}
                        </sui-list-item>
                </sui-list>
                </sui-form-field>
            </sui-form-fields>
        </div>

        <sui-divider section />
    </div>
</template>

<script>
    import store from '@/store';
    import { mapGetters } from 'vuex';

    export default {
        name: 'MediaConfig',
        props: {
            fetchMethod: String,
        },
        data() {
            return {
                isMediaFolderInputDisabled: false,
                isMediaFetchMethodInputDisabled: false,
            }
        },
        methods: {
            validateMediaFolder() {
                if (this.mediaFolder.startsWith('/') === false) {
                    this.mediaFolder = `/` + this.mediaFolder;
                }
            },
        },
        computed: {
            ...mapGetters(['activeGateway']),
            mediaFetchMethod: {
                get() {
                    return this.activeGateway.configuration.mediaConfiguration.fetchMethod;
                }
            },
            mediaFolder: {
                get() {
                    return this.activeGateway.configuration.mediaConfiguration.folder;
                },
                set(value) {
                    this.activeGateway.configuration.mediaConfiguration.folder = value;
                }
            },
            mediaDataField: {
                get() {
                    return this.activeGateway.configuration.mediaConfiguration.dataField;
                },
                set(value) {
                    this.activeGateway.configuration.mediaConfiguration.dataField = value;
                }
            },
            state: {
                get() { return store.state; }
            },
        }
    }
</script>
